<script>
import { healthRecordService } from '@/src/services/safehaven/HealthRecordService'

export default {
  mounted() {
    this.validateUrl()
  },
  methods: {
    async validateUrl() {
      try {
        const obj = {
          uid: this.$route?.path.split('/')[3],
          token: this.$route?.path.split('/')[4],
        }
        const responseData = await healthRecordService.vaidateDocumentUrl(obj)
        if (responseData) {
          if (responseData.data.has_revoked) {
            this.$router.push({
              name: 'share-health-record-link-revoked',
              params: { base: 'health-vault' },
            })
          } else if (responseData.data.has_expired) {
            this.$router.push({
              name: 'share-record-link-expired',
              params: { base: 'health-vault' },
            })
          } else {
            this.$router.push({
              name: 'health-vault-recipient-verification',
              params: {
                recipientData: responseData.data,
                uid: obj.uid,
                token: obj.token,
              },
            })
          }
        } else {
          this.$router.push({ name: 'share-record-link-expired' })
        }
      } catch (error) {
        console.warn(error)
        this.$router.push({
          name: 'share-record-link-expired',
        })
      }
    },
  },
}
</script>

<template>
  <v-progress-circular
    :size="150"
    :class="$style.loader"
    color="primary"
    indeterminate
  ></v-progress-circular>
</template>

<style lang="scss" module>
@import '@design';

.loader {
  display: flex;
  margin: auto;
  margin-top: 30vh;
}
</style>
